import { Component } from '@angular/core'
import { CurrentProductService } from '@spartacus/storefront'
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators'
import { MbProductTabReferencesConnector } from '../../../connectors'
import { isNotNullable } from '@spartacus/core'

@Component({
  selector: 'mb-pdp-references-tab',
  templateUrl: './pdp-references-tab.component.html',
  styleUrls: ['./pdp-references-tab.component.scss']
})
export class PdpReferencesTabComponent {

  product$ = this.currentProductService.getProduct().pipe(
    filter(isNotNullable),
  )
  references$ = this.product$.pipe(
    map(product => product.originalCode),
    filter(isNotNullable),
    distinctUntilChanged(),
    switchMap(productCode => this.mbProductTabReferencesConnector.get(productCode)),
  )

  constructor (protected currentProductService: CurrentProductService,
              protected mbProductTabReferencesConnector: MbProductTabReferencesConnector) {
  }
}
